import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose, withApollo } from 'react-apollo'
import { message, Avatar, Button, Row, Form, Input } from 'antd'
import { withFormik } from 'formik'
import * as yup from 'yup'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Wrapper, Logo } from './styles'
import { LOGIN } from '../../graphql/mutations'
import Version from '../../components/Version'
import { login } from '../../modules/auth'
// import API from '../../api/Http'
// import * as EndPoints from '../../api/EndPoints'

const logo = require('../../assets/images/g2g.png')

const FormItem = Form.Item

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    email: yup
      .string()
      .email()
      .required(),
    password: yup.string().required()
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { email, password } = values
  const { Login, client } = props

  let result

  try {
    result = await Login({
      variables: { email, password }
    })


  } catch (error) {
    message.error(error.message)
  }

  if (result) {
    // const response = await API.post(EndPoints.LOGIN, {email, password})
    localStorage.setItem('user-token', result.data.login.token)
    localStorage.setItem('username', result.data.login.user.name)
    // localStorage.setItem('g2g-token', response.data.data.token)
    client.resetStore()

    setSubmitting(false)
  }
}

export const Login = ({
  handleSubmit,
  isValid,
  handleChange,
  handleBlur,
  errors,
  touched
}) => {
  return (
    <React.Fragment>
      <Wrapper>
        <Logo>
          <Avatar src={logo} size={64} />
        </Logo>
        <form onSubmit={handleSubmit}>
          <FormItem
            hasFeedback
            help={touched.email && errors.email}
            validateStatus={touched.email && errors.email && 'error'}
          >
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="Email"
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </FormItem>
          <FormItem
            help={touched.password && errors.password}
            validateStatus={touched.password && errors.password && 'error'}
          >
            <Input.Password
              id="password"
              name="password"
              type="password"
              placeholder="Password"
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </FormItem>
          <Row>
            <Button htmlType="submit" type="primary" disabled={!isValid}>
              Sign In
            </Button>
          </Row>
        </form>
      </Wrapper>
      <Version />
    </React.Fragment>
  )
}

Login.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      login
    },
    dispatch
  )

export default compose(
  withApollo,
  graphql(LOGIN, { name: 'Login' }),
  withFormik({
    handleSubmit,
    validationSchema,
    displayName: 'LoginForm'
  })
)(connect(null, mapDispatchToProps)(Login))



// WEBPACK FOOTER //
// ./src/pages/Login/index.js